export const formatRows = (listaItems) => 
  listaItems.map((item) => ({
    id: item.id,
    codigo_rubro: item.codigo_rubro || "Código no disponible",  // Valor predeterminado en caso de que falte el código
    descripcion_rubro: item.descripcion_rubro || "Rubro disponible",  // Valor predeterminado
    descripcion_ramo: item.su_ramo?.descripcion_ramo || "Ramo no disponible",  // Usar optional chaining para evitar errores si su_ramo es null o undefined
  }));
